import {AgentSessionId, AgentSessionMessageFilter, CreateAgentSessionUserMessage} from "platformed-client/types";
import {platformedClient} from ".";

export async function listMessages(agentSessionId: AgentSessionId, args: AgentSessionMessageFilter) {
  return await platformedClient.internalRequest(
    "get",
    `/region/{region}/api/agent_sessions/{agent_session_id}/messages`,
    {path: {agent_session_id: agentSessionId}, query: args},
  );
}

export async function sendMessage(agentSessionId: AgentSessionId, message: CreateAgentSessionUserMessage) {
  await platformedClient.internalRequest("post", `/region/{region}/api/agent_sessions/{agent_session_id}/messages`, {
    path: {agent_session_id: agentSessionId},
    body: message,
  });
}
